import React, { useState, useEffect } from 'react';
import './About.css';
import homeCrmImage from './home-crm.png';

const About = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Set loaded state when component mounts
    setIsLoaded(true);
    
    // Add a slight delay for the animation to make it more noticeable
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <div id="about" className="about-container">
        <h1 className="about-section-title">HR, CRM, and Project Management System</h1>
        <div className="about-content">
          <div className={`about-text ${isLoaded ? 'fade-in' : ''}`}>
            <p>The simplest and most powerful way to collaborate with your team.</p>
            <ul className="about-features-list">
              <li>All-in-one platform: PM, CRM, Billing, HR</li>
              <li>Flat-fee pricing, unlimited users</li>
              <li>White-label & on-premise options</li>
              <li>Fast setup, no IT headaches</li>
            </ul>
            <div className="about-buttons">
              <a href="https://app.projectofi.com/signup" className="about-btn trial-btn">Start 14 day free trial</a>
            </div>
          </div>
          <div className={`about-image ${isVisible ? 'slide-in' : ''}`}>
            <div className="image-container">
              <div className="image-loader"></div>
              <img 
                src={homeCrmImage} 
                alt="Worksuite Dashboard" 
                loading="lazy"
                onLoad={() => setIsLoaded(true)}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default About;
